(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _swipers = _interopRequireDefault(require("./modules/swipers.js"));
var _accordion = _interopRequireDefault(require("./modules/accordion.js"));
var _hamburger = _interopRequireDefault(require("./modules/hamburger.js"));
var _animate = _interopRequireDefault(require("./modules/animate.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Import JS classes

// Initiate JS classes
var swprs = new _swipers["default"]();
var accrdn = new _accordion["default"]();
var hmbrgr = new _hamburger["default"]();
var anmte = new _animate["default"]();

},{"./modules/accordion.js":2,"./modules/animate.js":3,"./modules/hamburger.js":4,"./modules/swipers.js":5}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var accordion = /*#__PURE__*/function () {
  function accordion() {
    _classCallCheck(this, accordion);
    this.events();
  }
  _createClass(accordion, [{
    key: "events",
    value: function events() {
      var _this = this;
      document.addEventListener("DOMContentLoaded", function () {
        _this.accordion();
      });
    }
  }, {
    key: "accordion",
    value: function accordion() {
      var acc = document.getElementsByClassName("accordion");
      var i;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          console.log(panel);
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = '400px';
          }
        });
      }
    }
  }]);
  return accordion;
}();
var _default = accordion;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var animate = /*#__PURE__*/function () {
  function animate() {
    _classCallCheck(this, animate);
    this.events();
  }
  _createClass(animate, [{
    key: "events",
    value: function events() {
      document.addEventListener('scroll', this.scrollCheck.bind(this));
    }
  }, {
    key: "scrollCheck",
    value: function scrollCheck() {
      var _this = this;
      this.divs = document.querySelectorAll(".animate-left, .animate-right, .animate-grow, .animate-fade");
      this.divs.forEach(function (div) {
        if (_this.isInViewport(div, 20)) {
          if (div.classList.contains('animate-left')) {
            div.classList.remove('animate-left');
            div.classList.add("slide-left");
          } else if (div.classList.contains('animate-right')) {
            div.classList.remove('animate-right');
            div.classList.add("slide-right");
          } else if (div.classList.contains('animate-grow')) {
            div.classList.remove('animate-grow');
            div.classList.add('grow');
          } else if (div.classList.contains('animate-fade')) {
            div.classList.remove('animate-fade');
            div.classList.add('fade');
          }
        }
      });
    }
  }, {
    key: "isInViewport",
    value: function isInViewport(el, percentVisible) {
      this.rect = el.getBoundingClientRect();
      this.windowHeight = window.innerHeight || document.documentElement.clientHeight;
      return !(Math.floor(100 - (this.rect.top >= 0 ? 0 : this.rect.top) / +-this.rect.height * 100) < percentVisible || Math.floor(100 - (this.rect.bottom - this.windowHeight) / this.rect.height * 100) < percentVisible);
    }
  }]);
  return animate;
}();
var _default = animate;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var hamburger = /*#__PURE__*/function () {
  function hamburger() {
    _classCallCheck(this, hamburger);
    this.events();
  }
  _createClass(hamburger, [{
    key: "events",
    value: function events() {
      var _this = this;
      document.addEventListener("DOMContentLoaded", function () {
        _this.Menu();
      });
    }
  }, {
    key: "Menu",
    value: function Menu() {
      var mobile_button = document.querySelector('.mobile-button-container');
      var mobile_menu = document.querySelector('.mobile-menu-container');
      mobile_button.addEventListener('click', function () {
        if (mobile_menu.classList.contains("open")) {
          mobile_button.classList.remove("clicked");
          mobile_menu.classList.remove("open");
          document.querySelector('.mobile-menu-container').style.maxHeight = null;
        } else {
          mobile_button.classList.add("clicked");
          mobile_menu.classList.add("open");
          document.querySelector('.mobile-menu-container').style.maxHeight = '100vh';
        }
      });
    }
  }]);
  return hamburger;
}();
var _default = hamburger;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var swipers = /*#__PURE__*/function () {
  function swipers() {
    _classCallCheck(this, swipers);
    _defineProperty(this, "swiper", new Swiper('.swiper', {
      // Optional parameters
      speed: 500,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 8000,
        disableOnInteraction: false
      }
    }));
    _defineProperty(this, "swiper_diensten", new Swiper('.swiper-diensten', {
      // Optional parameters
      speed: 500,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.diensten-right',
        prevEl: '.diensten-left'
      },
      pagination: {
        el: ".swiper-pagination"
      }
    }));
    _defineProperty(this, "swiper_cta", new Swiper('.swiper-cta', {
      // Optional parameters
      speed: 500,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    }));
    this.events();
  }
  _createClass(swipers, [{
    key: "events",
    value: function events() {
      var _this = this;
      document.addEventListener("DOMContentLoaded", function () {
        _this.swiper;
        _this.swiper_diensten;
        _this.swiper_cta;
      });
    }
  }]);
  return swipers;
}();
var _default = swipers;
exports["default"] = _default;

},{}]},{},[1]);
